module.exports = __webpack_public_path__ + "img/1-3.35f4f136.png";